module.exports = __webpack_public_path__ + "media/video3.b5477b79.mp4";